import { graphql } from "gatsby"
import React from "react"
import {
  Base,
  Box, Button, Container, Flex,
  Heading, HeroBody, Section,
  Text
} from "./ui"
import * as styles from "./ui.css"
import ReactHtmlParser from 'react-html-parser'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function Banner(props) {
  return (
    <Base as="div" cx={[styles.bannerSection]}>
      <Flex cx={[styles.herosectionFlex]} gap={0}>
        <Base as="div" cx={[styles.herosectionTextBoxOuter]}>
          <Base as="div" cx={[styles.bannersectionTextBox]}>
            <Text variant={'kickerHowItWorks'}>
              {props.heading}
            </Text>
            <HeroBody variant="herobody2">
              {props.text}
            </HeroBody>
            <Button to={'#heroForm'} variant='primary' cx={[styles.bannerButton]}>
              Contrate para sua empresa <FontAwesomeIcon icon={faArrowRightLong} />
            </Button>
          </Base>
        </Base>
        <Base as="div" cx={[styles.bannerImageBox]}>
          <Base as="div" cx={[styles.imageCompleteBannerWrapper]}>
            <Base as="div" cx={[styles.imageCompleteBanner]}>
              <Base
                as={GatsbyImage}
                placeholder='none'
                alt={props.deco.alt}
                image={getImage(props.deco.gatsbyImageData)}
                className={[styles.decoImage]}
              />
              <Base
                as={GatsbyImage}
                placeholder='none'
                alt={props.mockups.alt}
                image={getImage(props.mockups.gatsbyImageData)}
                className={[styles.mockupImage]}
              />
            </Base>
          </Base>
          <Flex cx={[styles.bannerBackgroundFlex]} gap={0}>
            <Base as='div' cx={[styles.rightBackContainerFitness]} />
            <Base as='div' cx={[styles.rightBackContainerMind]} />
            <Base as='div' cx={[styles.rightBackContainerMedical]} />
            <Base as='div' cx={[styles.rightBackContainerFinancial]} />
          </Flex>
        </Base>
      </Flex>
    </Base>
  )
}

export const query = graphql`
  fragment HomepageBannerContent on HomepageBanner {
    id
    heading
    text
    mockups {
      id
      gatsbyImageData
      alt
    }
    deco {
      id
      gatsbyImageData
      alt
    }
  }
`
